/**
 * Cancellation policy types.
 *
 * A cancellation policy is classified by how far before arrival a guest may
 * cancel without penalty. These are the only machine-readable types the
 * platform accepts for new policies.
 */
export const CANCELLATION_POLICY_TYPE = {
    FLEXIBLE_24_HR: 'FLEXIBLE_24_HR',
    MODERATE_48_HR: 'MODERATE_48_HR',
    STRICT_72_HR: 'STRICT_72_HR',
    NON_REFUNDABLE: 'NON_REFUNDABLE',
};
export const CANCELLATION_POLICY_TYPE_OPTIONS = [
    { value: CANCELLATION_POLICY_TYPE.FLEXIBLE_24_HR, label: 'Flexible 24-hour' },
    { value: CANCELLATION_POLICY_TYPE.MODERATE_48_HR, label: 'Moderate 48-hour' },
    { value: CANCELLATION_POLICY_TYPE.STRICT_72_HR, label: 'Strict 72-hour' },
    { value: CANCELLATION_POLICY_TYPE.NON_REFUNDABLE, label: 'Non-refundable' },
];
//# sourceMappingURL=cancellation-policy-types.js.map